// Lib
import React from 'react';
import { useDropzone } from 'react-dropzone';

// Styles
import { useStyles } from './DropZoneStyles';

const Dropzone = ({ onDrop, accept, children }) => {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept,
    onDrop,
  });

  const { classes, cx } = useStyles({ isDragActive });

  return (
    <div {...getRootProps({ className: cx('dropzone', classes.root) })}>
      <input className="input-zone" {...getInputProps()} />
      {children}
    </div>
  );
};
export default Dropzone;
